module.exports = __webpack_public_path__ + "static/media/SolidSnake.b49024db.png";